module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bread-crumb', {
    attrs: {
      "routeName": 'Solutions',
      "subRoute": _vm.solution_name
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('hero', {
    attrs: {
      "backgroundImage": _vm.slide_image,
      "content": _vm.slide_label
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "has-primary-background section"
  }, [_c('p', {
    staticClass: "subtitle is-5 is-white content",
    domProps: {
      "innerHTML": _vm._s(_vm.solution_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [(_vm.case_study) ? _c('div', {
    staticClass: "column is-6"
  }, [_c('a', {
    staticClass: "m-b-50 is-red title is-4 is-hoverable",
    attrs: {
      "href": ("https://" + (this.baseURL()) + "/" + _vm.case_study_pdf),
      "download": ""
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right"
    }
  }), _vm._v(" Download case study\n          ")], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless"
  }, _vm._l((_vm.related), function(solution, index) {
    return _c('div', {
      staticClass: "column",
      class: {
        'm-r-10': index < 2 && _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet),
          'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet),
      }
    }, [_c('card', {
      attrs: {
        "to": ("solutions/" + (solution.solution_name)),
        "red": true,
        "background": ("https://" + (_vm.baseURL()) + "/" + (solution.slide_image.path)),
        "subtitle": solution.slide_label,
        "title": solution.solution_name,
        "height": "40vh"
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd34010","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/pages/solutions.vue
// module id = 1131
// module chunks = 1